export default __webpack_public_path__ + "e29d66ebad92bebe9682c5e1e5c493c5.woff";